import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {ContactoServicio, ContactoServicioBase, ContactoServicioPayload} from './contactos-servicios.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactosServiciosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(crm_contacto_id: number): Observable<GenericHttpResponse<ContactoServicio[]>> {
    const url = this.httpCommonService.makeUrl('/crms/contactosServicios', {crm_contacto_id});
    return this.http.get<GenericHttpResponse<ContactoServicio[]>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<ContactoServicio>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactosServicios/${id}`);
    return this.http.get<GenericHttpResponse<ContactoServicio>>(url);
  }

  store(body: ContactoServicioPayload): Observable<GenericHttpResponse<ContactoServicioBase>> {
    const url = this.httpCommonService.makeUrl('/crms/contactosServicios');
    return this.http.post<GenericHttpResponse<ContactoServicioBase>>(url, body);
  }

  update(id: number, body: ContactoServicioPayload): Observable<GenericHttpResponse<ContactoServicioBase>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactosServicios/${id}`);
    return this.http.put<GenericHttpResponse<ContactoServicioBase>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<ContactoServicioBase>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactosServicios/${id}`);
    return this.http.delete<GenericHttpResponse<ContactoServicioBase>>(url);
  }
}
